import { useMutation, useQueryClient } from "react-query";

import { thirdParty } from "../utils";

export interface IUseAddProductMutationParameters {
    checkoutId: string;
    productVariantId: string;
}

export const useAddProduct = (invalidQueryKeys: string[] = []) => {
    const queryClient = useQueryClient();

    const {
        mutateAsync,
        mutate,
        isIdle,
        isLoading,
        data,
        error,
        isError,
        isSuccess,
    } = useMutation({
        mutationFn: async (parameters: IUseAddProductMutationParameters) => {
            const { checkoutId, productVariantId } = parameters;
            return await thirdParty.shopify.addProduct(
                checkoutId,
                productVariantId,
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: invalidQueryKeys,
            });
        },
    });

    return {
        mutate,
        mutateAsync,
        isLoading,
        data,
        error,
        isIdle,
        isError,
        isSuccess,
    };
};
